import React from 'react';
import './AdminHeader.css';

const AdminHeader = () => {
  return (
    <header className="admin-header">
      <div className="admin-header-left ms-3">
        <img
          src="/Images/AMB.svg"
          alt="Anemia Mukt Bharat"
          className="admin-logo"
        />
        <img
          src="/Images/Nhm.svg"
          alt="National Health Mission"
          className="admin-logo"
        />
      </div>

      <div className="admin-header-right d-none d-md-flex">
        {/* <img
          src="/images/stamp.svg"
          alt="National Health Mission"
          className="admin-logo"
        /> */}
        <h6 className="admin-header-title ms-3">AMB Dashboard</h6>
      </div>
    </header>
  );
};

export default AdminHeader;